import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common/common.service";
import { environment } from "src/environment/environment";

@Component({
  selector: "app-complaints-help",
  templateUrl: "./complaints-help.component.html",
  styleUrls: ["./complaints-help.component.css"],
})
export class ComplaintsHelpComponent {
  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {}
  customerActionLogsId: any;
  org_ids: any;
  contacts:any [] = [];
  rowspanMap: { [key: string]: number } = {};
  // gmEmail: string = "@grindmaster.co.in";
  ngOnInit() {
    this.getSupportTeamMastertList();
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    const payload = {
        "customerActionLogsId": this.customerActionLogsId
    }; 

    this.commonService
      .customerHelpline(payload)
      .subscribe((e: any) => {});
  }

  getSupportTeamMastertList() {
    this.org_ids = localStorage.getItem("org_id");
      const postObj = {
        modelName: "support_team_master",
          whereCondition: {
            organization_id: this.org_ids,
            isActive: 1,
            type:"Customer Portal"
          },
          orderBy: {field: "sequence", order: "asc"},
          "pagination": {
            "page": 1,
            "pageSize": 100
        },
      };
      this.http
        .post<any>(`${environment.url}/common/getRecords`, postObj)
        .subscribe(
          (response: any) => {
            if (response?.code == 1) {
              this.contacts = response?.data;
              this.calculateRowspan();
            } else {
              console.log("No response for Support Team list.");
            }
          },
          (error) => {
            console.error("Error fetching Support Team list:", error);
          }
        );
    }

    //rowspan
    calculateRowspan() {
      this.rowspanMap = {};
      this.contacts.forEach((contact, index) => {
        if (index === 0 || contact.team_name !== this.contacts[index - 1].team_name) {
          this.rowspanMap[contact.team_name] = 1;
        } else {
          this.rowspanMap[contact.team_name]++;
        }
      });
    }
  
    shouldShowRow(team_name: string, index: number): boolean {
      return index === 0 || team_name !== this.contacts[index - 1].team_name;
    }
}
